// extracted by mini-css-extract-plugin
export var bottomRightDock = "_26-0";